import { useSignalListener, Signals } from '@/contexts/SignalingContext';
import { ErrorCode, AppError } from '@/types/errors';
import { DEFAULT_ICE_CONFIG } from './constants';
import { Action } from './types';
import React from 'react';

interface SignalHandlerDeps {
  localStream: MediaStream | null;
  error: AppError | null;
  setError: (error: AppError | null) => void;
  addLocalTracks: (stream: MediaStream) => void;
  dispatch: React.Dispatch<Action>;
  setIceConfiguration: (config: RTCConfiguration) => void;
}

/**
 * Sets up all signal listeners for VideoChatContent component
 */
export function useVideoChatSignalHandlers(deps: SignalHandlerDeps) {
  const {
    localStream,
    error,
    setError,
    addLocalTracks,
    dispatch,
    setIceConfiguration
  } = deps;

  // Handle Start signal
  useSignalListener(Signals.Start, (message) => {
    console.log('Start received');
    if (!localStream) {
      if (!error) {
        console.error('No local stream available');
        setError({ code: ErrorCode.NoLocalStream });
      }
      return;
    }
    addLocalTracks(localStream);
  });

  // Handle Peer Connection Details
  useSignalListener(Signals.PeerConnectionDetail, (message) => {
    console.log('Peer connection detail received');
    if (message.connection) {
      dispatch({ type: 'SET_PEER_DETAILS', payload: message.connection.peerId });
    }
  });

  // Handle User Data
  useSignalListener(Signals.UserData, (message) => {
    console.log('User data received');
    if (message.user) {
      dispatch({ type: 'SET_USER_DATA', payload: message.user });
    }
  });

  // Handle ICE Servers
  useSignalListener(Signals.ICEServers, (message) => {
    console.log('ICE servers received', message.iceServers);
    if (!message.iceServers) {
      // TODO: Handle this properly
      return;
    }

    const iceConfig: RTCConfiguration = {
      iceServers: message.iceServers,
      ...DEFAULT_ICE_CONFIG
    };
    setIceConfiguration(iceConfig);
  });
}